import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import "./home.scss";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import Table from "../../components/table/Table";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { setAdminType } from "../../../reduxtool/userSlice";

const Home = () => {
  const dispatch = useDispatch();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const userId = useSelector((state) => state.user.userId);

  const [countUser, setCountUser] = useState(0);
  const [countNews, setCountNews] = useState(0);
  const [countGhar, setCountGhar] = useState(0);
  const [adminTypes, setAdminTypes] = useState("");
  const [products, setProducts] = useState(0);
  const [trecking, setTrecking] = useState(0);
  const [events, setEvents] = useState(0);
  const [videos, setVideos] = useState(0);

  const [totalYearlyRevenue, setTotalYearlyRevenue] = useState(0);
  const [totalVisitors, setTotalVisitors] = useState(0);
  const [totalVisitorRevenue, setTotalVisitorRevenue] = useState(0);
  const [monthToday, setMonthToday] = useState(0);
  const [yearToday, setYearToday] = useState(0);
  const [people, setPeople] = useState(0);

  useEffect(() => {
    if (!userId) {
      navigate("/");
      return;
    }

    const fetchRevenueVisitor = async () => {
      try {
        const response = await axios.get(
          BASE_URL + `/api/visitor/visitorCount/${userId}`,
        );
        if (response.data) {
          if (adminTypes === "sAdmin") {
            setTotalYearlyRevenue(0);
            setTotalVisitors(0);
            setTotalVisitorRevenue(0);
            setMonthToday(response.data.monthToday);
            setYearToday(response.data.yearToday);
          } else {
            setTotalYearlyRevenue(response.data.totalFinance);
            setTotalVisitors(response.data.visitorCount);
            setTotalVisitorRevenue(response.data.totalVisitorFinance);
            setMonthToday(response.data.monthToday);
            setYearToday(response.data.yearToday);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };

    const fetchCounts = async () => {
      try {
        const response = await axios.get(
          BASE_URL + `/api/users/countAllUser/${userId}`,
        );
        if (response.data) {
          setCountUser(response.data.countUser);
          setCountNews(response.data.countNews);
          setCountGhar(response.data.countGhar);
          setAdminTypes(response.data.adminType);
          setProducts(response.data.countBazar);
          setTrecking(response.data.countTravel);
          setEvents(response.data.countEvents);
          setVideos(response.data.countVideos);
          setPeople(response.data.countPeople);

          // Sync with Redux when data arrives
          // dispatch(setAdminType(response.data.adminType));
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchRevenueVisitor();
    fetchCounts();
  }, [userId, navigate, adminTypes, BASE_URL, dispatch]);

  return (
    <div className="home">
      <Sidebar /> {/* Removed adminTypeMenu prop as it now uses Redux */}
      <div className="homeContainer">
        <Navbar />
        <div className="widgets">
          <Widget type="people" countValue={people} linkRoute={"/people"} />
          <Widget type="news" countValue={countNews} linkRoute="/news" />
          <Widget type="ghar" countValue={countGhar} linkRoute="/ghar" />
          <Widget type="product" countValue={products} linkRoute={"/market"} />
          <Widget type="trecking" countValue={trecking} linkRoute={"/travel"} />
          <Widget type="events" countValue={events} linkRoute={"/events"} />
          <Widget type="user" countValue={countUser} linkRoute="/users" />
          <Widget type="videos" countValue={videos} linkRoute={"/gtak"} />
        </div>
        <div className="charts">
          <Featured
            type="revenue"
            totalYearlyRevenue={totalYearlyRevenue}
            monthToday={monthToday}
            adminTypes={adminTypes}
            yearToday={yearToday}
          />
          <Featured
            type="visitor"
            totalVisitors={totalVisitors}
            totalVisitorRevenue={totalVisitorRevenue}
            monthToday={monthToday}
            yearToday={yearToday}
          />
          <Chart title="Last 6 Months (Revenue)" aspect={2 / 1} />
        </div>
        <div className="listContainer">
          <div className="listTitle">Club Members</div>
          <Table />
        </div>
      </div>
    </div>
  );
};

export default Home;
